import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { getApiEnv } from "../../../../config/env";
import { Text } from "../../../../components/general/Text";

const ToggleButton = styled.button`
  padding: 10px;
  border: none;
  background-color: #4caf50;
  color: white;
  cursor: pointer;
  width: 100%;
  text-align: center;
  &:hover {
    background-color: #45a049;
  }
`;

const EnvironmentToggle: React.FC = () => {
  const [environment, setEnvironment] = useState(getApiEnv());
  const storeEnv = GlobalStore.useState(s => s.envOverride);
  useEffect(() => {
    if (environment !== storeEnv) {
      GlobalStore.update(s => {
        s.envOverride = environment as "PROD" | "UAT";
      });
    }
  }, [environment, storeEnv]);

  const toggleEnvironment = () => {
    setEnvironment(env => (env === "PROD" ? "UAT" : "PROD"));
  };

  return (
    <div>
      <Text size={"Medium"} textStyle={"Paragraph"}>
        Current Environment: {environment}
      </Text>
      <ToggleButton onClick={toggleEnvironment}>
        <Text size={"Medium"} textStyle={"Paragraph"}>
          Switch to {environment === "PROD" ? "UAT" : "PROD"}
        </Text>
      </ToggleButton>
    </div>
  );
};

export default EnvironmentToggle;
